import React from "react";

import { mobileScreenType } from "@stadium/constants";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import EmbededLinkTag from "@sendmagic/prismic-nextjs/src/components/EmbededLinkTag";

const DEFAULT_ALIGNMENT = "align-center";

const BannerSection = ({
  banner_logo_text,
  top_header_text,
  heading,
  subheading,
  background_image,
  mobileImageUrl = "",
  internal_link_id,
  bg_video,
  items = [],
  conditionalClass,
  sectionStyle,
  StartOrderBtn,
  video_embeded_text,
  video,
  alignment_dropdown = DEFAULT_ALIGNMENT,
}) => (
  <div
    className={`container-2xl position-relative py-md-5 py-5 text-banner-section ${alignment_dropdown} prismic-slice ${conditionalClass}`}
    style={sectionStyle}
  >
    {internal_link_id && (
      <span id={internal_link_id} className="scroll-point position-absolute d-block" />
    )}
    {bg_video?.url && (
      <div className="video-bg-container">
        <video
          className="video-bg"
          poster={background_image?.url}
          autoPlay="autoplay"
          muted="muted"
          loop="loop"
        >
          <source src={bg_video?.url} />
        </video>
      </div>
    )}
    {mobileImageUrl && (
      <div className="text-center text-only-banner-mobile-image">
        <PrismicImgix
          className="img-responsive img-responsive-height"
          src={mobileImageUrl}
          alt={mobileImageUrl}
          desktop="320px"
          mobile="250px"
          tablet="240px"
          largeDisplay="700px"
        />
      </div>
    )}
    {banner_logo_text && (
      <div className="container d-flex align-items-center banner-logo text-left text-uppercase fs-12px lh-24px ls-1-3px mb-3 mb-md-0">
        <p className="mr-1 font-weight-bold">{textResolver(banner_logo_text)}</p>
        <span className="banner-border ml-3" />
      </div>
    )}

    <div className="container pt-0 pt-md-5 text-center text-banner-container">
      {top_header_text && (
        <div className="mb-3 mb-md-2 text-banner-header-top-text same-size-title">
          {textResolver(top_header_text)}
        </div>
      )}
      <div className="mx-auto position-relative sns-h2 font-weight-bold text-white text-banner-heading same-size-title">
        {textResolver(heading)}
      </div>
      <div className="mt-md-4 mt-2 mx-auto position-relative font-weight-bold sns-h3 text-banner-title same-size-title">
        {textResolver(subheading)}
      </div>

      <div className="d-flex flex-wrap flex-md-nowrap justify-content-center mt-md-5 start-an-order-home-btn position-relative text-only-banner-btns-row">
        {items.map(({ link, link_text, start_an_order, button_design }, idx) => {
          const backgroundBtnClass =
            "px-5 py-3 btn-block text-white font-weight-bold no-underline text-uppercase text-break ls-3px button-marketing";
          const btnClass = {
            solid_background: `button button-program-green ${backgroundBtnClass}`,
            transparent_background: `button button-program-outline-green btn ${backgroundBtnClass}`,
            link_without_border: "sns-h4 program-link text-uppercase font-weight-bold ls-3px",
            "button-filled-beige": "button-filled-beige",
            "button-bordered-beige": "button-bordered-beige",
            "button-empty-beige": "button-empty-beige",
          };

          return (
            <div key={`program-index-${idx}`} className="mt-2 mt-md-0 mx-2 text-only-banner-btn">
              {start_an_order && StartOrderBtn ? (
                <StartOrderBtn className={`${btnClass[button_design]} my-0`}>
                  {textResolver(link_text)}
                </StartOrderBtn>
              ) : (
                link?.url && (
                  <PrismicLinkTag
                    urlText={link_text}
                    url={link?.url}
                    target={link?.target}
                    className={btnClass[button_design]}
                  />
                )
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-3 text-only-banner-link-row">
        <EmbededLinkTag embededObj={video} urlText={video_embeded_text} className="text-white" />
      </div>
    </div>
  </div>
);

const TextOnlyBanner = ({ doc: { primary = {}, items = [] }, StartOrderBtn, currentDevice }) => {
  const {
    background_image,
    mobile_background_image,
    mobile_only_header_img,
    bg_color = "black",
    bg_video,
  } = primary;

  const isMobileView = currentDevice === mobileScreenType;

  const imageUrl = (currentDevice == mobileScreenType ? mobile_background_image : background_image)
    ?.url;
  const sectionImage = appendBackgroundImage(imageUrl);

  const sectionColor = { backgroundColor: bg_color };

  const mobileImageUrl = isMobileView
    ? mobile_background_image?.url || mobile_only_header_img?.url
    : "";

  const conditionalClass = bg_video?.url ? "video-bg-slice" : "";

  return (
    <div style={sectionColor}>
      <BannerSection
        sectionStyle={sectionImage}
        mobileImageUrl={mobileImageUrl}
        conditionalClass={conditionalClass}
        StartOrderBtn={StartOrderBtn}
        items={items}
        {...primary}
      />
    </div>
  );
};

export default TextOnlyBanner;
